import React from 'react';
import { Header } from './Header';
import { Questions } from './Questions';


export const Game = () => {
  return (
    
    <div>
        <Header /> 
        <Questions />
    </div>
    
  )
};
